<template>
  <FlexCol gap-3>
    <Flex justify-end gap-3>
      <ButtonExport v-if="!hideExport" :api="route" name="Exportar Materiais Baixados" v-model:filters="osFilter" />
      <Button primary icon="fa-solid fa-plus" label="Adicionar Material" @click="openAddDialog" />
    </Flex>

    <TheTable :headers="headersMaterial" :items="items" disablePagination :loader="loader" dense cell-border>
      <template #idMaterial="{ item }">
        <span class="roboto-mono-400">{{ item.itemCode || item.idMaterial }}</span>
      </template>
      <template #name="{ item }">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else class="italic">Material Não Registrado</span>
      </template>
      <template #quantity="{ item }">
        {{ formatQuantity(item.quantity) }}
      </template>
      <template #actions="{ item }">
        <Flex gap-2>
          <TheToolTip label="Editar">
            <TableIconButton icon="fa-pen" @click="openMaterialDialog(item)" />
          </TheToolTip>
          <TheToolTip label="Excluir">
            <TableIconButton class="fa-trash" @click="openRemoveDialog(item)" />
          </TheToolTip>
        </Flex>
      </template>
    </TheTable>

    <Modal title="Editar Materiais" v-model="dialogMaterial" size="w-4/12">
      <template #default>
        <FlexCol gap-4>
          <InputZoom
            v-model="objectMaterial.idMaterial"
            label="Material"
            database="item"
            itemText="name"
            itemValue="code"
            required
            clearable
            :error="errors.idMaterial ? [errors.idMaterial] : null"
          />
          <InputNumber v-model="objectMaterial.quantity" label="Quantidade" required :error="errors.quantity" />
        </FlexCol>
      </template>
      <template #footer>
        <Button primary icon="fa-solid fa-save" label="Salvar" @click="save()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>

    <Modal title="Remover Material" v-model="dialogDelete" size="w-3/12">
      <template #default>Deseja remover o material?</template>
      <template #footer>
        <Button primary label="Remover" @click="removeAcept()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>
  </FlexCol>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { get, insert, remove, update } from '@/crud'
import { useStore } from 'vuex'

const props = defineProps({
  protocolo: String,
  idOs: Number,
  hideExport: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['osMaterialDats'])
const store = useStore()

const route = 'osMaterial'
const dialogMaterial = ref(false)
const dialogDelete = ref(false)
const objectMaterial = ref({})
const loader = ref(false)
const items = ref([])
const errors = ref({})

const headersMaterial = [
  { title: 'Material', field: 'idMaterial', disableOrder: true },
  { title: 'Nome', field: 'name', disableOrder: true },
  { title: 'Quantidade', field: 'quantity', disableOrder: true },
  { title: 'Ações', field: 'actions', disableOrder: true },
]

const osFilter = computed(() => [{ column: 'protocolo', operator: '=', value: props.protocolo }])

const formatQuantity = (value) => {
  if (value === null || value === undefined || value === '') return '0'
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric.toLocaleString('pt-BR') : value
}

const openAddDialog = () => {
  errors.value = {}
  objectMaterial.value = {}
  dialogMaterial.value = true
}

const openMaterialDialog = (material) => {
  errors.value = {}
  objectMaterial.value = { ...material }
  dialogMaterial.value = true
}

const openRemoveDialog = (material) => {
  objectMaterial.value = { ...material }
  dialogDelete.value = true
}

const cancelDialog = () => {
  dialogMaterial.value = false
  dialogDelete.value = false
}

const loadItem = async () => {
  if (!props.protocolo) {
    items.value = []
    return
  }

  loader.value = true
  const query = { params: { filters: [{ column: 'protocolo', value: props.protocolo }] } }
  const response = await get(route, query)
  items.value = response.error ? [] : response.data || []

  emits('osMaterialDats', {
    headers: headersMaterial,
    content: items.value,
  })
  loader.value = false
}

const save = async () => {
  const id = objectMaterial.value.id
  const payload = {
    idOs: props.idOs,
    protocolo: props.protocolo,
    idMaterial: objectMaterial.value.idMaterial,
    quantity: objectMaterial.value.quantity,
  }

  const response = id ? await update(route, id, payload, 'material') : await insert(route, payload, 'material')
  errors.value = response.error ? response.data : {}
  if (response.error) return

  dialogMaterial.value = false
  await loadItem()
}

const removeAcept = async () => {
  const result = await remove(route, objectMaterial.value.id, 'material')
  if (result && !result.error) {
    store.dispatch('setSuccess', { message: 'Removido com sucesso' })
  } else {
    store.dispatch('setError', { message: result?.data })
  }
  await loadItem()
  cancelDialog()
}

onMounted(() => {
  loadItem()
})

watch(
  props,
  () => {
    loadItem()
  },
  { deep: true },
)
</script>
